import React from "react";
import { BorderProps, ColorProps, SpaceProps, TypographyProps } from "styled-system";
import { Button } from "../Button";
import { MenuItemLink } from "../MenuItemLink";

export const LoginButton: React.FC<ColorProps & TypographyProps & BorderProps & SpaceProps> = props => (
  <MenuItemLink to="/dashboard" {...props} hover={false}>
    <Button variant="accent" fontSize={1} data-testid="actonBar-login-button">
      login
    </Button>
  </MenuItemLink>
);
